import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const clientRoot = () => `${LocalStorage.getClientPrefix()}/cruddatabase`
const root = 'cruddatabase'

class CadastroDBService {
  about () {
    return Api().get(`${root}/about`)
  }

  testConnection (databaseDto) {
    return Api()
      .post(`${root}/test-connection`, databaseDto)
      .then(response => response.data)
  }

  insert (item) {
    return Api().post(root, item)
  }

  classnames () {
    return Api().get(`${root}/classnames`)
  }

  update (item) {
    return Api().put(root, item)
  }

  findAll () {
    return Api().get(clientRoot())
  }

  delete ({ tenant }) {
    return Api().delete(`${clientRoot()}/${tenant}`)
  }

  findById (id) {
    return Api().get(`${clientRoot()}/${id}`)
  }
}

export default new CadastroDBService()
